import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';
import { RepairCodeSearchComponent } from '../../components/repair-code/repair-code-search/repair-code-search.component';
import { RepairCodeGridComponent } from '../../components/repair-code/repair-code-grid/repair-code-grid.component';
import { RepairCodeFiltersComponent } from '../../components/repair-code/repair-code-filters/repair-code-filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NavigationStart, Router, RouterLink, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RepairCodeFilterForm } from '../../form-model/repair-code-filter.form.model';
import { RepairCodeSearchTextForm } from '../../form-model/repair-code-search-text.form.model';
import { RepairCodeService } from '../../services/repair-code.service';
import { ReplaySubject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-repair-code-list',
    templateUrl: './repair-code.component.html',
    styleUrls: ['./repair-code.component.scss'],
    imports: [RepairCodeSearchComponent, RouterLink, RouterModule, RepairCodeGridComponent, RepairCodeFiltersComponent, NgxSkeletonLoaderModule, ReactiveFormsModule, CommonModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class RepairCodeListComponent implements OnInit, OnDestroy {
    filterFormGroup = this.formBuilder.group({
        repairCodeFilterForm: this.formBuilder.group<RepairCodeFilterForm>({} as RepairCodeFilterForm),
        repairCodeSearchTextForm: this.formBuilder.group<RepairCodeSearchTextForm>({} as RepairCodeSearchTextForm)
    });

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly repairCodeService: RepairCodeService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        // Use NavigationStart (fires BEFORE component destruction) so we know
        // the TARGET url — unlike router.url in ngOnDestroy which may still
        // show the current page url at the time of destruction.
        this.router.events
            .pipe(takeUntil(this.destroyed$))
            .subscribe(event => {
                if (event instanceof NavigationStart) {
                    if (!event.url.startsWith('/master-data/repair-code')) {
                        this.repairCodeService.setRepairCodeFilterFormValue(null);
                    }
                }
            });
    }

    ngOnDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
